import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback } from 'react';
import { useField } from 'formik';

/**
 * Обертка над useField из Formik для работы с состоянием числового поля.
 *
 * @param {TUseFormNumberFieldProps} props - Параметры поля.
 */
export function useFormNumberField(props) {
  var _useField = useField(props),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var onChange = useCallback(function (e) {
    /**
     * onChange компонента NumberInput (@cian/ui-kit) получает не объект события,
     * а сразу значение из поля, поэтому для его сохранения в Formik используется helpers.setValue().
     */
    helpers.setValue(e, false);
    /** При вводе в поле ошибка будет сбрасываться, если есть */

    if (meta.error) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      helpers.setError(undefined);
    }
  }, [helpers, meta.error]);
  return {
    field: _objectSpread(_objectSpread({}, field), {}, {
      onChange: onChange
    }),
    meta: meta,
    helpers: helpers
  };
}